import basquiatPrintImage from "../../../image/originals/hollywoodicons/basquiatprint.webp";
import princessDianaImage from "../../../image/originals/hollywoodicons/PrincessDiana_590x.webp";
import brittanyMurphyImage from "../../../image/originals/hollywoodicons/brittanymurphy.webp";
import audreyHepburnPrintImage from "../../../image/originals/hollywoodicons/audreyprint.webp";
import audreyBreakfastAtTiffanysPrintImage from "../../../image/originals/hollywoodicons/audreybreakfastprint.webp";
import whitneyHoustonPrintImage from "../../../image/originals/hollywoodicons/whitney.webp";
import leftEyePrintImage from "../../../image/originals/hollywoodicons/lisalefteye.webp";
import aaliyahPrintImage from "../../../image/originals/hollywoodicons/aaliyah.webp";
import marilynMonroePrintImage from "../../../image/originals/hollywoodicons/marilyn.jpg";
import princessLeiaPrintImage from "../../../image/originals/hollywoodicons/princessleia.webp";
import risksPrintImage from "../../../image/originals/quantum/RISKS.webp";
import leapsPrintImage from "../../../image/originals/quantum/LEAPS.webp";
import groundedForYouPrintImage from "../../../image/originals/quantum/GROUNDED.webp";
import selenePrincessPrintImage from "../../../image/originals/quantum/Selene_Princess.webp";
import selenePrintImage from "../../../image/originals/quantum/seleneprint.webp";
import paradoxPrintImage from "../../../image/originals/quantum/paradox.webp";
import floatingInSpacePrintImage from "../../../image/originals/quantum/floating.webp";
import twinFlamePrintImage from "../../../image/originals/quantum/twinFlame.webp";
import riseOfKobePrintImage from "../../../image/originals/hollywoodicons/kobeprint.webp";

import Collection from "../Collection";

const Prints = () => {
  const items = [
    {
      title: "Risks Print",
      imageUrl: risksPrintImage,
      projectUrl: "/RisksPrint",
    },
    {
      title: "Leaps Print",
      imageUrl: leapsPrintImage,
      projectUrl: "/LeapsPrint",
    },
    {
      title: "Twin Flame Print",
      imageUrl: twinFlamePrintImage,
      projectUrl: "/TwinFlamePrint",
    },
    {
      title: "“The Rise of Kobe” Art Print",
      imageUrl: riseOfKobePrintImage,
      projectUrl: "/TheRiseOfKobeArtPrint",
    },
    {
      title: "Grounded For You Print",
      imageUrl: groundedForYouPrintImage,
      projectUrl: "/GroundedForYouPrint",
    },
    {
      title: "Selene Princess Print",
      imageUrl: selenePrincessPrintImage,
      projectUrl: "/SelenePrincessPrint",
    },
    {
      title: "Paradox Print",
      imageUrl: paradoxPrintImage,
      projectUrl: "/ParadoxPrint",
    },
    {
      title: "Floating in Space Print",
      imageUrl: floatingInSpacePrintImage,
      projectUrl: "/FloatingInSpacePrint",
    },
    {
      title: "Whitney Houston Print",
      imageUrl: whitneyHoustonPrintImage,
      projectUrl: "/WhitneyHoustonPrint",
    },
    {
      title: "Left Eye Print",
      imageUrl: leftEyePrintImage,
      projectUrl: "/LeftEyePrint",
    },
    {
      title: "Audrey Hepburn (Breakfast at Tiffanys) Print",
      imageUrl: audreyBreakfastAtTiffanysPrintImage,
      projectUrl: "/AudreyHepburnBreakfastPrint",
    },
    {
      title: "Aaliyah Print",
      imageUrl: aaliyahPrintImage,
      projectUrl: "/AaliyahPrint",
    },
    {
      title: "Princess Leia Print",
      imageUrl: princessLeiaPrintImage,
      projectUrl: "/PrincessLeiaPrint",
    },
    {
      title: "Selene Print",
      imageUrl: selenePrintImage,
      projectUrl: "/SelenePrint",
    },
    {
      title: "Audrey Hepburn Print",
      imageUrl: audreyHepburnPrintImage,
      projectUrl: "/AudreyHepburnPrint",
    },
    {
      title: "Marilyn Monroe Print",
      imageUrl: marilynMonroePrintImage,
      projectUrl: "/MarilynMonroePrint",
    },
    {
      title: "Brittany Murphy Print",
      imageUrl: brittanyMurphyImage,
      projectUrl: "/BrittanyMurphyPrint",
    },
    {
      title: "Princess Diana Original",
      imageUrl: princessDianaImage,
      projectUrl: "/PrincessDianaOriginal",
    },
    {
      title: "Jean-Michel Basquiat Print",
      imageUrl: basquiatPrintImage,
      projectUrl: "/BasquiatPrint",
    },
  ];

  return (
    <Collection
      items={items}
      title="Limited Edition Prints"
      variant="boutique"
      eyebrow="Limited Edition Prints"
      description="Collectible art prints featuring iconic portraits, quantum-inspired pieces, and signature Reena Tolentino editions."
      pageClassName="collection-page--prints"
      showFooter
    />
  );
};

export default Prints;
